/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ keyCmd: NonNullable<unknown>, shortcutName: NonNullable<unknown> }} Shortcut_Keys_Conflict_TextInputs */

const en_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" is currently assigned to "${i?.shortcutName}". Do you want to reassign it to this shortcut?`)
};

const fr_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" est actuellement attribué à "${i?.shortcutName}". Voulez-vous le réattribuer à ce raccourci ?`)
};

const de_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" ist derzeit "${i?.shortcutName}" zugewiesen. Möchten Sie sie dieser Verknüpfung neu zuweisen?`)
};

const it_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" è attualmente assegnato a "${i?.shortcutName}". Vuoi riassegnarlo a questa scorciatoia?`)
};

const ru_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" в настоящее время назначено "${i?.shortcutName}". Переназначить его на это сочетание?`)
};

const es_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" está asignado actualmente a "${i?.shortcutName}". ¿Desea reasignarlo a este atajo?`)
};

const zh_cn2_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" 当前已分配给 "${i?.shortcutName}"。是否将其重新分配给此快捷方式？`)
};

const ja_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" は現在 "${i?.shortcutName}" に割り当てられています。このショートカットに再割り当てしますか?`)
};

const hi_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" वर्तमान में "${i?.shortcutName}" को असाइन किया गया है। क्या आप इसे इस शॉर्टकट को फिर से असाइन करना चाहते हैं?`)
};

const pt_pt2_shortcut_keys_conflict_text = /** @type {(inputs: Shortcut_Keys_Conflict_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.keyCmd}" está atualmente atribuído a "${i?.shortcutName}". Deseja reatribuí-lo a este atalho?`)
};

/**
* | output |
* | --- |
* | "\"{keyCmd}\" is currently assigned to \"{shortcutName}\". Do you want to reassign it to this shortcut?" |
*
* @param {Shortcut_Keys_Conflict_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_conflict_text = /** @type {((inputs: Shortcut_Keys_Conflict_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Conflict_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_conflict_text(inputs)
	if (locale === "de") return de_shortcut_keys_conflict_text(inputs)
	if (locale === "it") return it_shortcut_keys_conflict_text(inputs)
	if (locale === "ru") return ru_shortcut_keys_conflict_text(inputs)
	if (locale === "es") return es_shortcut_keys_conflict_text(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_conflict_text(inputs)
	if (locale === "ja") return ja_shortcut_keys_conflict_text(inputs)
	if (locale === "hi") return hi_shortcut_keys_conflict_text(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_conflict_text(inputs)
	return en_shortcut_keys_conflict_text(inputs)
});